import { useGetFundraisingStatus } from '@/query/queries/fundraising/useGetFundraisingStatus';

export const useFundraisingStatus = () => {
  const { data } = useGetFundraisingStatus();

  const isParticipating = data?.goal >= 0; // FF created, brand is participating

  return {
    data,
    isParticipating
  };
};
